import { render, staticRenderFns } from "./garden8.vue?vue&type=template&id=549514a2"
import script from "./garden8.vue?vue&type=script&lang=js"
export * from "./garden8.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports